import { Timestamp } from '@angular/fire/firestore';

export interface SchoolBilling {
  id: string;
  groupId: string;
  stripeCustomerId: string;

  paidTier: PaidTier;

  name: string;
  description: string;

  payerId: string;
  payerName: string;
  payerEmail: string;

  paymentDate: Timestamp;

  products: any[];

  updated: Timestamp;
  updatedById: string;
}

export enum PaidTier {
  FREE = 'Free Tier',
  BASIC = 'Basic Tier',
  PREMIUM = 'Premium Tier',
}

export enum BillingActions {
  SETUP_PAYMENTS = 'Setup Payments',
  MAKE_PENDING_PAYMENTS = 'Pending Payments',
  STORAGE_ADD_ON = 'Storage Add-On',
}
